import React, { Component } from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import LoadingPanel from "../common/LoadingPanel";
import { logController } from "../../controllers/log.controller";
import { LogLevel } from "../../enums";

class PdfViewer extends Component {
    state = {
        show: false,
        loading: false,
        print: false,
        pdfFile: null
    };

    shouldComponentUpdate(nextProps) {
        if (this.props.loading !== nextProps.loading || this.props.pdfFile !== nextProps.pdfFile || this.props.show !== nextProps.show) {
            if (this.props.show !== nextProps.show && nextProps.show === false) {
                this.onClose();
            } else {
                this.setState({
                    show: nextProps.loading ? true : this.state.show,
                    loading: nextProps.loading,
                    print: nextProps.print,
                    pdfFile: nextProps.pdfFile
                });
            }
        }

        return true;
    }

    printPdf() {
        var iframe = document.frames ? window.frames.frames["print-file"] : document.getElementById("print-file");
        var ifWin = iframe.contentWindow || iframe;
        try {
            ifWin.focus();
            ifWin.print();
        } catch (e) {
            logController.logMessage(e, LogLevel.Error);
            //window.print(false);
            //or when you get Invalid calling object error for IE9 and above
            //set the browser into IE8 compatibility mode will work
        }
    }

    onClose = () => {
        this.setState({
            show: false,
            loading: false,
            print: false,
            pdfFile: null
        });
    };

    render() {
        return (
            <React.Fragment>
                {this.state.show && (
                    <Dialog title="PDF Viewer" width="90%" height="90%" onClose={this.onClose}>
                        {this.state.loading ? (
                            <LoadingPanel />
                        ) : (
                            <iframe
                                title="pdf document"
                                id="print-file"
                                src={this.state.pdfFile}
                                width="100%"
                                height="100%"
                                onLoad={() => {
                                    if (this.state.print) this.printPdf();
                                }}
                            />
                        )}
                    </Dialog>
                )}
            </React.Fragment>
        );
    }
}

export default PdfViewer;



// WEBPACK FOOTER //
// ./src/components/common/PdfViewer.js